import styles from "../landing-page-mobile-one.module.css";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { useAnalyticsTracker } from "analytics-tracker";

const carouselImages = [
  {
    src: "/landing-page/landing-mobile-one/Section4/image1.webp",
    alt: "Map poster with photos - Seven Sisters hike",
  },
  {
    src: "/landing-page/landing-mobile-one/Section4/image2.webp",
    alt: "Colorful running race posters on wall",
  },
  {
    src: "/landing-page/landing-mobile-one/Section4/image3.webp",
    alt: "Pastel colored map posters",
  },
  {
    src: "/landing-page/landing-mobile-one/Section4/image4.webp",
    alt: "West Highland Way photo collage poster",
  },
];

interface GiftSectionMobileProps {
  onClick: () => void;
}

export const GiftSectionMobile = (props: GiftSectionMobileProps) => {
  const { trackEvent } = useAnalyticsTracker();

  const handleCarouselClick = (imageIndex: number) => {
    trackEvent("Mobile landing CTA clicked", { section: "gift", button: "carousel_image", imageIndex });
    props.onClick();
  };

  const handleCTAClick = () => {
    trackEvent("Mobile landing CTA clicked", { section: "gift", button: "design_a_gift" });
    props.onClick();
  };

  return (
    <section className={styles.giftSection}>
      <h2 className={styles.giftTitle}>THE PERFECT PERSONALISED GIFT</h2>
      <p className={styles.giftSubtitle}>
        Start with one of our beautifully crafted presets and add your own
        photos and labels.
      </p>
      <p className={styles.giftSubtitle}>
        Change fonts, colours, map style, and much more.
      </p>
      <div className={styles.giftCarousel}>
        {carouselImages.map((image, index) => (
          <button
            key={index}
            className={styles.giftCarouselButton}
            onClick={() => handleCarouselClick(index)}
          >
            <img
              src={image.src}
              alt={image.alt}
              className={styles.giftCarouselImage}
            />
          </button>
        ))}
      </div>
      <CTAButton
        variant="SECONDARY"
        title="DESIGN A GIFT"
        onClick={handleCTAClick}
        className={styles.sectionCTA}
      />
    </section>
  );
};
